import { render, staticRenderFns } from "./SearchDropdownForm.vue?vue&type=template&id=6e90e58b&scoped=true&"
import script from "./SearchDropdownForm.vue?vue&type=script&lang=js&"
export * from "./SearchDropdownForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchDropdownForm.vue?vue&type=style&index=0&id=6e90e58b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e90e58b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default,SearchAutocomplete: require('/app/appsumo/nuxt/components/search/SearchAutocomplete.vue').default})
